export interface SampleStrategyItem {
  shortName: string;
  longName: string;
  code: string;
  bgColor: string;
  percentage: string;
}

export enum DisplayName {
  SHORT_NAME = 'short_name',
  LONG_NAME = 'long_name',
  CODE = 'code',
  TICKER_SHORT_NAME = 'ticker_short_name',
}

export interface TooltipItem {
  key: string;
  value: string;
  isIdentifier?: boolean;
}
